import moment from 'moment';
import JsPDF from 'jspdf';
import bmHannaAirBase64 from '@/assets/fonts/bmHannaAir.js';
import Util from '@/util';
import callChannelType from '@/constants/callChannelType';

let storeName = getStoreNameByCallType();

const packageConfig = require('@/../package.json');

const BrowserFS = require('browserfs');

let fs;
let fileName;
let writeQueue = [];
let isWriting = false;

BrowserFS.install(window);

const create = () => {
  fileName = `/[${storeName}]${moment(new Date()).format('YYYY-MM-DD')}.txt`;
  if (BrowserFS) {
    BrowserFS.configure({ fs: 'IndexedDB', options: { storeName: storeName } }, (err) => {
      fs = window.require('fs');
      if (!err) {
        unlink();
        const header = `### ${storeName} [ver.${packageConfig.version}] : ${moment(new Date()).format('YYYY-MM-DD')} ###\n`;
        fs.appendFile(fileName, header, 'utf8', (err) => {
          if (err) console.log('Error writing header:', err);
        });
      }
    });
  }
};

const processQueue = () => {
  if (writeQueue.length > 0 && !isWriting && fs) {
    isWriting = true;
    const { text } = writeQueue.shift();
    const logEntry = `${moment(new Date()).format('HH:mm:ss')} ${text}\n`;
    fs.appendFile(fileName, logEntry, 'utf8', (err) => {
      isWriting = false;
      if (err) {
        console.log('Error during file write:', err);
      }
      // Process the next task in the queue
      processQueue();
    });
  }
};

const write = (text) => {
  writeQueue.push({ text });
  processQueue();
};

const download = (key) => {
  return new Promise((resolve, reject) => {
    fs.readFile(`/[${storeName}]${key.substr(1).replace(/\*/g, '-')}.txt`, 'utf8', (err, data) => {
      if (err) {
        reject(err);
      } else {
        const pdf = new JsPDF({
          encryption: {
            userPassword: `#${key.substr(1).replace(/\*/g, '*')}_u`,
            ownerPassword: `#${key.substr(1).replace(/\*/g, '*')}`,
            userPermissions: ['modify']
          }
        });

        // 폰트 추가 및 설정
        pdf.addFileToVFS('bmHannaAir.ttf', bmHannaAirBase64);
        pdf.addFont('bmHannaAir.ttf', 'bmHannaAir', 'normal');
        pdf.setFont('bmHannaAir');
        pdf.setFontSize(10);

        // 텍스트를 여러 페이지에 분할하는 로직
        let lines = pdf.splitTextToSize(data, 180);
        let y = 10;
        for (let i = 0; i < lines.length; i++) {
          if (y > 280) {
            pdf.addPage();
            y = 10; // 새 페이지 상단에서 시작
          }
          pdf.text(lines[i], 10, y);
          y += 10; // 다음 텍스트 줄의 위치
        }

        pdf.save(`[${storeName}]${key.substr(1).replace(/\*/g, '-')}.pdf`);
        resolve();
      }
    });
  });
};

const unlink = () => {
  fs.readdir('/', (err, files) => {
    if (!err) {
      const maxSize = 30;
      let fileSize = files.length;
      if (fileSize > maxSize) {
        files.forEach((file) => {
          if (fileSize > maxSize) {
            fs.unlink(file);
            fileSize = fileSize - 1;
          }
        });
      }
    }
  });
};

const reset = () => {
  setTimeout(() => {
    fs = null;
    fileName = null;
  }, 500);
};

const getFileList = () => {
  return new Promise((resolve, reject) => {
    let fileList = [];
    if (!fs) {
      fs = window.require('fs');
    }
    fs.readdir('/', (err, files) => {
      if (!err) {
        fileList = files
          .filter((file) => {
            return file.indexOf(storeName) !== -1;
          })
          .map((file) => {
            let fileName = file.replace(`[${storeName}]`, '');
            return fileName.replace('.txt', '');
          });

        resolve(fileList);
      } else {
        reject(err);
      }
    });
  });
};

function getStoreNameByCallType() {
  const callType = Util.getCallTypeFromToken();
  switch (callType) {
    case callChannelType.NEOMECCA:
      return 'NeomeccaLogReport';
    case callChannelType.KT:
      return 'KtLogReport';
    case callChannelType.KLCNS:
      return 'KlcnsLogReport';
    case callChannelType.NEO_WEB_RTC:
      return 'NeomeccaWebRtcLogReport';
    default:
      return 'NeomeccaLogReport';
  }
}

export default {
  create,
  write,
  download,
  reset,
  getFileList
};



// WEBPACK FOOTER //
// ./src/util/logReport.js